import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import DocumentMeta from 'react-document-meta';

export default class FestivalOurSponsorLogos extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let sponsors = this.props.sponsors;


    let sponsorList;
    sponsorList = sponsors.map((sponsor) => {
      return <div className="festivalSponsors-wrapperInner">
                <div className="festivalSponsors-logoWrapperParent"><div className="festivalSponsors-logoWrapperChild"><a href={sponsor.sponsor_website_url}><img src={sponsor.sponsor_logo} /></a></div></div>
            </div>
    })



    return(
        <div className="festivalSponsors-wrapper">
          {sponsorList}
        </div>
    );
  }

};



// WEBPACK FOOTER //
// ./src/components/festival/sponsorship/FestivalOurSponsorLogos.jsx